import AnnotationsHandler from '..';
import EnvironmentInfo from '../../environment-info';
import Constants from '../../constants';
import { C11nEnv } from '../../interpreter/c11n-env';

AnnotationsHandler.registerHandler('@ENV', (value: string, c11nEnv: C11nEnv) => {
  switch (value) {
    case Constants.ENV_INFO_KEYS.APPLICATION_NAME:
      return EnvironmentInfo.getApplicationName();
    case Constants.ENV_INFO_KEYS.ACCESS_GROUP:
      return EnvironmentInfo.getAccessGroup();
    case Constants.ENV_INFO_KEYS.USER_NAME:
      return EnvironmentInfo.getOperatorName();
    case Constants.ENV_INFO_KEYS.USER_ID:
      return EnvironmentInfo.getOperatorIdentifier();
    case Constants.ENV_INFO_KEYS.APPLICATION_DESC:
      return c11nEnv
        .getLocalizationService('APP!APPLICATION')
        .getLocalizedText(EnvironmentInfo.getApplicationLabel() || '');
    case Constants.ENV_INFO_KEYS.USER_IMAGE:
      return EnvironmentInfo.getOperatorImageInsKey();
    case Constants.ENV_INFO_KEYS.LOCALE:
      return EnvironmentInfo.getUseLocale();
    case Constants.ENV_INFO_KEYS.TIMEZONE:
      return EnvironmentInfo.getTimeZone();
    case Constants.ENV_INFO_KEYS.WORK_GROUP:
      return EnvironmentInfo.getOperatorWorkGroup();
    default:
      return value;
  }
});
